module.exports = __webpack_public_path__ + "static/media/confcp_102.fe848488.ico";